import {
  WSActions,
  WSForm,
  WSInputText,
  WSList,
  WSSelect,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { queriesRoles } from "@query";
import { ErrorAlert } from "@components/ErrorAlert";
import { validatorEmail } from "../../../shared/validators/validatorEmail";

export type FormStakeholderValues = {
  email: string;
  roleId: string;
};

export interface FormStakeholderProps {
  isEdit?: boolean;
  title: string;
  submitButtonLabel: string;
  loading?: boolean;
  error?: unknown;
  onBack: () => void;
  defaultValues: FormStakeholderValues;
  onSubmit: (data: FormStakeholderValues) => Promise<void>;
}

export const FormStakeholder: React.FC<FormStakeholderProps> = props => {
  const queryRoles = queriesRoles.listRoles.useQueryAll();

  const roleOptions = (queryRoles.flatData ?? []).map(role => ({
    label: role.name || (role.id as string),
    value: role.id as string
  }));

  return (
    <WSForm<FormStakeholderValues>
      onSubmit={props.onSubmit}
      defaultValues={props.defaultValues}
      validationSchema={Yup.object().shape({
        email: validatorEmail.required("Email is required"),
        roleId: Yup.string().required("Role is required")
      })}
    >
      <WSList gap="XL">
        <WSText.Heading4>{props.title}</WSText.Heading4>

        <WSForm.Field
          name="email"
          label="Email"
          component={WSInputText}
          componentProps={{
            type: "email",
            disabled: props.isEdit
          }}
        />

        <WSForm.Field
          name="roleId"
          label="Role"
          component={WSSelect}
          componentProps={{
            options: roleOptions,
            placeholder: "Select a role"
          }}
        />

        <ErrorAlert error={props.error} context="TeamStakeholder" />

        <WSActions
          alignment="fill"
          buttons={[
            {
              label: props.submitButtonLabel,
              loading: props.loading
            },
            {
              label: "Cancel",
              kind: "Tertiary",
              type: "button",
              onClick: props.onBack
            }
          ]}
        />
      </WSList>
    </WSForm>
  );
};
